import { render, staticRenderFns } from "./MaklerContactBox.vue?vue&type=template&id=fa7cc948&"
import script from "./MaklerContactBox.vue?vue&type=script&lang=js&"
export * from "./MaklerContactBox.vue?vue&type=script&lang=js&"
import style0 from "./MaklerContactBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VIcon})
